import React, { useState, useEffect } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import {
  CBadge,
  CCard,
  CCardBody,
  CButton,
  CCardHeader,
  CCol,
  CDataTable,
  CRow,
  CPagination,
  CModal,
  CModalHeader,
  CModalBody,
  CModalFooter,
  CForm,
  CFormGroup,
  CFormText,
  CLabel,
  CInput, CInputGroup, CInputGroupText
} from 'compat/coreui'

import axios from 'axios';
import moment from 'moment';

const getBadge = status => {
  switch (status) {
    case 'Active': return 'success'
    case 'Inactive': return 'secondary'
    case 'Pending': return 'warning'
    case 'Banned': return 'danger'
    default: return 'primary'
  }
}

const Category = () => {
  const history = useNavigate()
  const [modal, setModal] = useState(false);
  const [title, setTitle] = useState('');
  const [subTitle, setSubTitle] = useState('');
  const [categoryData, setCategoryData] = useState([]);


  const toggle = () => {
    setModal(!modal);
  }

  useEffect(async () => {
    getData()
  }, [])

  function getData() {
    axios.get(`${process.env.REACT_APP_APP_API_URL}/api/category`, {
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem('token')
      }
    }).then(res => {
      setCategoryData(res.data.list);
    }).catch(e => console.log(e))
  }

  const addCategory = (e) => {
    e.preventDefault();

    // console.log('hello category', e.target.value, title, subTitle);
    const token = localStorage.getItem('token');
    axios({
      url: `${process.env.REACT_APP_APP_API_URL}/api/category`,
      method: 'POST',
      headers: {
        'Authorization': 'Bearer ' + token
      },
      data: {
        "parent": null,
        "title": title,
        "subTitle": subTitle,
        "image": null,
      }
    }).then(response => {
      console.log("category response", response);
      if (response.data.status) {
        getData();
        setTitle('');
        setSubTitle('');
        setModal(false);
      }
    }).catch(console.log)
  }
  const deleteItem = (id) => {
    window.alert(
      'Are you sure to delete',
      'alertMessage',
      [
        { text: 'Cancel', onPress: () => console.log('Cancel Pressed!') },
        { text: 'OK', onPress: deleteApiCall(id) },
      ],
      { cancelable: false }
    )
  }
  const deleteApiCall = (id) => {
    axios.get(`${process.env.REACT_APP_APP_API_URL}/api/category/remove?cat=1&categoryId=` + id, {
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem('token')
      }
    }).then(res => {
      setCategoryData(res.data.list);
    }).catch(e => console.log(e))
  }
  return (
    <CRow>
      <CCol xl={12}>
        <CCard>
          <CCardHeader className="category_header">
            Category
          <CButton
              onClick={toggle}
              className="mr-1"
              color="success"
            >Add Category</CButton>
          </CCardHeader>
          <CCardBody>
            <CModal
              show={modal}
              onClose={toggle}
            >
              <CModalHeader closeButton>Add Category</CModalHeader>
              <CModalBody>
                <form onSubmit={addCategory}>
                  <CFormGroup>
                    <CLabel htmlFor="nf-title">Category Name</CLabel>
                    <CInput
                      type="text"
                      id="nf-title"
                      name="nf-title"
                      placeholder="Enter title.."
                      value={title}
                      onChange={e => setTitle(e.target.value)}
                    />
                    <CFormText className="help-block">Please enter category name</CFormText>
                  </CFormGroup>
                  <CFormGroup>
                    <CLabel htmlFor="nf-subtitle">Sub Category</CLabel>
                    <CInput
                      type="text"
                      id="nf-subtitle"
                      name="nf-subtitle"
                      placeholder="Enter subtitle.."
                      value={subTitle}
                      onChange={e => setSubTitle(e.target.value)}
                    />
                    <CFormText className="help-block">Please enter sub category</CFormText>
                  </CFormGroup>
                  <CButton color="primary" type="submit">Add</CButton>{' '}
                  <CButton
                    color="secondary"
                    onClick={toggle}>
                    Cancel
                  </CButton>
                </form>
              </CModalBody>
            </CModal>
            <div className="table-responsive"
            >
              <table className="table table-striped table-hover">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Title</th>
                    <th>Sub Title</th>
                    <th>Created At</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {categoryData.map((cat, index) => {
                    return (
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td>{cat.title}</td>
                        <td>{cat.subTitle}</td>
                        <td>{moment(cat.createdAt).format('YYYY-MM-DD HH:mm')}</td>
                        <td onClick={() => deleteItem(cat._id)}><i className="fa fa-times-circle"></i></td>
                      </tr>
                    )
                  })
                  }
                </tbody>
              </table>
            </div>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  )
}

export default Category;
